import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Card } from '@/components/ui/Surface/Card';
import { BandHead } from '@/components/ui/Typography/Heading/BandHead';
/**
 * タイトル付きの汎用カード表示コンポーネント
 * @param props
 * @constructor
 */
export const CardWithTitle = (props) => {
    const { children, className = '', isRounded = false, title = '', titleColor = 'gray', titleTextClassName = '', } = props;
    return (_jsxs(Card, Object.assign({ className: clsx('overflow-hidden', className), isRounded: isRounded, isShadow: true }, { children: [_jsx(BandHead, Object.assign({ bgColor: titleColor, className: 'w-full', fixTextPosition: 'center', textClassName: titleTextClassName }, { children: title })), children] })));
};
